import OrganisationApi from '@packages/organisations/api';

export class ReceivingAgentApi extends OrganisationApi {
    static resource = 'receiving-agents';
}

export default ReceivingAgentApi;
